import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=1a0176ce&scoped=true"
import script from "./MatchInfo.vue?vue&type=script&lang=js"
export * from "./MatchInfo.vue?vue&type=script&lang=js"
import style0 from "./MatchInfo.vue?vue&type=style&index=0&id=1a0176ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0176ce",
  null
  
)

export default component.exports